import { OnboardingGuideInterfaceNeverShowAgain } from "../../src/components/onboarding-guide/onboarding-guide-interface";
const fs = require("fs");
const output = `${__dirname}/../../resources/generated-mock-data/`;

const response: OnboardingGuideInterfaceNeverShowAgain = {success: true};

const writeToFile = (object: any, name: string) => {
    console.log(JSON.stringify(object));
    fs.writeFileSync(`${output}${name}.json`, JSON.stringify(object));
};

writeToFile(response, "onboarding-guide-never-show-again");